import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import '../../Styles/global/header.scss'
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import Drawer from './Drawer'

import { logout } from "../../store/actions/Auth";



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: "fixed",
    width: "100vw",
    marginBottom: "20px"

    // top : 0
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  links: {
    color: "white",
    margin: "0 2rem",
    fontWeight: "600",
    '&:hover': {
      color: "#225077"
    }
  }
}));

export default function MenuAppBar(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory()
  const location = useLocation()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [drawerOpen, setDrawerOpen] = useState(false)
  // const user = useSelector((state) => state.user);
  const session = sessionStorage.getItem('e') ? JSON.parse(sessionStorage.getItem('e')) : null
  const loggedIn = useSelector(({ user }) => user.loggedIn);
  const isLoggedIn = loggedIn
  const user = useSelector(state => state.user);


  const handleClick = () => {
    history.push("/login")
  }

  const handleLogout = () => {
    dispatch(logout())

    setAnchorEl(null);
  };

  // const toggleDrawer = ()=> {

  // }
  const toggleDrawer = (value) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    // setState({ drawerOpen: open });
    setDrawerOpen(!drawerOpen)
  };
  const onboarding = ['/onboarding', '/onboarding-bvn-verification', '/onboarding-personal-info', '/onboarding/extra-info', '/onboarding/create-pin']
  return (
    <div className={classes.root} id="app-bar">

      <AppBar position="static" id="app-bars">
        <Toolbar>

          <Typography variant="h6" className={classes.title}>
            {!isLoggedIn || (isLoggedIn && onboarding.includes(location.pathname)) ?
              <p></p>
              :

              <>
                <p id="desktop"></p>

                <IconButton id="mobile" edge="start" className={classes.menuButton} onClick={toggleDrawer(true)} color="inherit" aria-label="menu">
                  <MenuIcon />
                </IconButton>
              </>

            }
          </Typography>

          <div>

            {!isLoggedIn ?

              (<div></div>)
              : (
                <div>
                  <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleLogout}
                    color="inherit"
                  >
                    <ExitToAppRoundedIcon />
                  </IconButton>
                </div>
              )}

          </div>
        </Toolbar>


      </AppBar>

      <>
        {drawerOpen && <Drawer toggleDrawer={toggleDrawer} drawerOpen={drawerOpen} />}
      </>
    </div>
  );
}
